<script setup lang="ts">

import {Skeleton} from "@/core/components/ui/skeleton";
import DeprecatedGrouping from "@/core/interfaces/laboratory/Grouping";
import GroupingBranding from "@/core/interfaces/laboratory/GroupingBranding";
import GroupingTrialStatus from "@/trial/components/trial-status/GroupingTrialStatus.vue";

defineProps<{
    grouping: DeprecatedGrouping;
    branding?: GroupingBranding;
    isLoading: boolean;
}>();
</script>

<template>
  <div class="relative">
    <div class="absolute inset-0 bg-gradient-to-r gradient rounded-3xl transform -skew-y-1 shadow-2xl" />
    <div class="relative bg-white rounded-3xl shadow-xl overflow-hidden">
      <div class="relative p-8 lg:p-12">
        <div class="space-y-6">
          <div class="space-y-4">
            <div class="flex items-center gap-6 flex-wrap justify-between">
              <h1 class="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                {{ grouping.name }}
              </h1>

              <div v-if="grouping.branding?.logo?.renderPath" class="flex-shrink-0">
                <div class="relative group">
                  <div class="absolute inset-0 gradient rounded-2xl blur-lg opacity-25 group-hover:opacity-40 transition-opacity duration-300" />
                  <div class="relative bg-white p-4 rounded-2xl shadow-lg border border-gray-100 group-hover:shadow-xl transition-all duration-300">
                    <img
                      :src="grouping.branding.logo.renderPath"
                      alt="Logo du groupement"
                      class="h-16 w-auto max-w-[160px] object-contain"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="max-w-4xl">
            <div v-if="isLoading" class="relative">
              <div class="absolute left-0 top-0 w-1 h-full bg-gray-200 rounded-full" />
              <div class="pl-6 pr-4 py-4 bg-gray-50 rounded-r-xl border-l-4 border-gray-200 space-y-2">
                <Skeleton class="w-full h-4" />
                <Skeleton class="w-5/6 h-4" />
                <Skeleton class="w-4/6 h-4" />
              </div>
            </div>

            <div v-else-if="branding?.internalPresidentWord" class="relative">
              <div class="absolute left-0 top-0 w-1 h-full gradient rounded-full" />
              <blockquote
                class="pl-6 py-4 bg-gray-50 rounded-r-xl border-l-4 italic text-gray-700 leading-relaxed"
                v-html="branding.internalPresidentWord"
              />
              <div class="flex items-center mt-3 pl-6">
                <div class="w-2 h-2 bg-blue-500 rounded-full mr-3" />
                <span class="text-sm font-medium text-gray-600">Message du président</span>
              </div>
            </div>

            <GroupingTrialStatus class="pt-4" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
